import React from 'react';
import { styled } from '@compiled/react';
import LinkIcon from '@atlaskit/icon/glyph/link';
import { N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	color: string;
};

export const DependencyIcon = (props: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper color={props.color}>
			<LinkIcon
				size="small"
				primaryColor={token('color.icon.inverse', N0)}
				label={formatMessage(messages.tooltip)}
			/>
		</Wrapper>
	);
};

const ICON_SIZE = 20;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div<{ color: string }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: ({ color }) => color,
	display: 'flex',
	width: `${ICON_SIZE}px`,
	height: `${ICON_SIZE}px`,
	borderRadius: '50%',
	alignItems: 'center',
	justifyContent: 'center',
	boxShadow: token('elevation.shadow.raised', '0 2px 4px 0 rgba(0, 0, 0, 0.25)'),
});
